import { Component, h, Host, Listen } from '@stencil/core';
import { get, set } from './sidebar-form.store';
import { ResetPasswordFormKeys, SidebarFormTypes } from './sidebar-form-types.enum';

@Component({
  tag: 'sidebar-form',
  styleUrl: 'sidebar-form.scss',
})
export class SidebarForm {
  @Listen('resetState', { target: 'document' })
  resetState(event) {
    const { formId } = event.detail;
    if (formId === 'sidebarForm') {
      set('email', '');
      set('password', '');
      set('otp', '');
      set('currentForm', SidebarFormTypes.otp);
      set('loginErrors', null);
      set('resetPasswordFailed', false);
      set('otpFailed', false);
      set('sendOtpFailed', false);
      set('otpFormSubmitted', false);
      set('resetPasswordFormTitleKey', ResetPasswordFormKeys.default);
      sessionStorage.setItem('incorrectCredentialsCounter', `0`);
    }
  }

  translate = window['translate'];

  toggleForm() {
    set('currentForm',
      (
        get('currentForm') === SidebarFormTypes.login
          ? SidebarFormTypes.otp
          : SidebarFormTypes.login
      )
    );
    sessionStorage.setItem('incorrectCredentialsCounter', `0`);
    set('resetPasswordFormTitleKey', ResetPasswordFormKeys.default);
  }

  currentFormComponent() {
    switch (get('currentForm')) {
      case SidebarFormTypes.otp: {
        return <sidebar-form-otp />;
      }
      case SidebarFormTypes.login: {
        return <sidebar-form-login />;
      }
      case SidebarFormTypes.resetPassword: {
        return <sidebar-form-reset-password />;
      }
      default:
        return <sidebar-form-otp />;
    }
  }

  render() {
    return <Host>
      {this.currentFormComponent()}
    </Host>;
  }
}
